export default __webpack_public_path__ + "static/media/desktop_banner_motor.790b81d6.jpg";